<template>
  <v-dialog :value="value" @input="close" :persistent="busy" max-width="600px" scrollable>
    <v-card>
      <v-card-title>批量新增权限密钥</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedGroup"
          :items="groups"
          item-text="name"
          item-value="sgid"
          label="服务器身份组"
          :loading="loadingGroups"
          :disabled="busy || submitted"
          no-data-text="暂无可用身份组"
        ></v-autocomplete>
        <v-text-field
          v-model.number="count"
          label="数量"
          type="number"
          min="1"
          max="100"
          :rules="[value => Number.isInteger(value) && value >= 1 && value <= 100 || '请输入 1～100 的整数']"
          :disabled="busy || submitted"
        ></v-text-field>
        <v-alert v-if="error" type="error" text class="mt-4">
          {{ error }}
          <div v-if="batchId" class="text-caption">批次：{{ batchId }}</div>
        </v-alert>
        <v-alert v-if="keys.length" type="success" text class="mt-4">
          已为“{{ resultGroup }}”创建 {{ keys.length }} 把权限密钥
        </v-alert>
        <key-text-field
          v-for="(key, index) in keys"
          :key="key"
          :value="key"
          :label="'密钥 ' + (index + 1)"
        ></key-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="keys.length" text color="primary" @click="copyAll">全部复制</v-btn>
        <v-btn v-else text color="primary" :loading="busy" :disabled="!canSubmit" @click="create">创建</v-btn>
        <v-btn text color="primary" :disabled="busy" @click="close">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createBatchKeys } from "@/api/batchKeys.mjs";

export default {
  components: { KeyTextField: () => import("@/components/KeyTextField") },
  props: { value: Boolean },
  data() {
    return { groups: [], selectedGroup: undefined, count: 10, loadingGroups: false,
      busy: false, submitted: false, keys: [], resultGroup: "", error: "", batchId: "" };
  },
  computed: {
    canSubmit() {
      return !this.busy && !this.submitted && !this.loadingGroups &&
        this.groups.some(group => group.sgid === this.selectedGroup) &&
        Number.isInteger(this.count) && this.count >= 1 && this.count <= 100;
    },
  },
  methods: {
    close() {
      if (!this.busy) this.$emit("input", false);
    },
    copyAll() {
      this.$clipboard(this.keys.join("\n"));
      this.$toast.info("已复制全部密钥");
    },
    async create() {
      if (!this.canSubmit) return;
      this.busy = true;
      this.submitted = true;
      this.error = "";
      const group = this.groups.find(item => item.sgid === this.selectedGroup);
      try {
        this.keys = await createBatchKeys({ socket: this.$socket, token: this.$store.state.query.token,
          serverId: this.$store.state.query.serverId, groupName: group.name, count: this.count });
        this.resultGroup = group.name;
        this.$toast.success("已创建 " + this.keys.length + " 把权限密钥");
        this.$emit("tokens-created");
      } catch (error) {
        this.error = error.message;
        this.batchId = error.batchId || "";
        this.$toast.error(error);
        this.$emit("refresh");
      } finally {
        this.busy = false;
      }
    },
  },
  async created() {
    this.loadingGroups = true;
    try {
      this.groups = (await this.$TeamSpeak.execute("servergrouplist")).filter(group => group.type === 1);
    } catch (error) {
      this.error = "读取身份组失败，请关闭后重试";
      this.$toast.error(error);
    } finally {
      this.loadingGroups = false;
    }
  },
};
</script>
